module.exports = __webpack_public_path__ + "static/media/background6.2deea36b.png";